import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FaqComponent} from "./faq.component";
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [FaqComponent],
  exports: [FaqComponent],
})
export class FaqModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/faq/faq.module.ts